<!-- Step 1: Select Terminal -->
<div *ngIf="currentStep === 1" class="fiserv-pos-step">
  <h4 class="fiserv-pos-step__title">Select Terminal</h4>

  <div *ngIf="loadingTerminals" class="fiserv-pos-loading">Loading terminals...</div>

  <div *ngIf="!loadingTerminals && terminals.length === 0" class="fiserv-pos-empty">
    No terminals registered for this clinic. Contact your administrator.
  </div>

  <div *ngIf="!loadingTerminals && terminals.length > 0">
    <div *ngFor="let terminal of terminals; trackBy: trackByHsn"
      class="fiserv-pos-device-row"
      [class.fiserv-pos-device-row--selected]="selectedHsn === terminal.hsn"
      (click)="selectTerminal(terminal)">

      <span class="fiserv-pos-device-row__indicator"
        [class.fiserv-pos-device-row__indicator--connected]="pingStatus[terminal.hsn] === true"
        [class.fiserv-pos-device-row__indicator--disconnected]="pingStatus[terminal.hsn] === false">
      </span>

      <span class="fiserv-pos-device-row__name">
        {{ terminal.label ?? terminal.hsn }}
      </span>

      <span class="fiserv-pos-device-row__model" *ngIf="terminal.terminalModel">
        {{ terminal.terminalModel }}
      </span>

      <button class="fiserv-pos-btn fiserv-pos-btn--link"
        [disabled]="pingingHsn === terminal.hsn"
        (click)="$event.stopPropagation(); pingTerminal(terminal.hsn)">
        {{ pingingHsn === terminal.hsn ? 'Pinging...' : 'Ping' }}
      </button>

    </div>

    <div class="fiserv-pos-actions">
      <button class="fiserv-pos-btn fiserv-pos-btn--primary"
        [disabled]="!selectedHsn"
        (click)="goToStep2()">
        Next
      </button>
    </div>
  </div>
</div>

<!-- Step 2: Enter Amount -->
<div *ngIf="currentStep === 2" class="fiserv-pos-step">
  <h4 class="fiserv-pos-step__title">Payment Amount</h4>

  <div class="fiserv-pos-field">
    <label class="fiserv-pos-label">Amount ($)</label>
    <input class="fiserv-pos-input"
      type="number" min="0.01" step="0.01"
      [ngModel]="displayAmountDollars"
      (ngModelChange)="displayAmountDollars = $event"
      placeholder="0.00" />
  </div>

  <div class="fiserv-pos-actions fiserv-pos-actions--split">
    <button class="fiserv-pos-btn fiserv-pos-btn--secondary" (click)="backToStep1()">Back</button>
    <button class="fiserv-pos-btn fiserv-pos-btn--primary"
      [disabled]="saleAmountCents <= 0"
      (click)="startPayment()">
      Charge {{ displayAmountLabel }} on Terminal
    </button>
  </div>
</div>

<!-- Step 3: Processing — spinner waiting for HTTP response, NO polling -->
<div *ngIf="currentStep === 3" class="fiserv-pos-step fiserv-pos-step--centered">
  <div class="fiserv-pos-spinner"></div>
  <p class="fiserv-pos-status-text">
    Waiting for card on {{ selectedTerminalLabel ?? selectedHsn }}...
  </p>
  <p class="fiserv-pos-elapsed">{{ elapsedSeconds }}s elapsed</p>
  <p class="fiserv-pos-hint">Present card on the terminal to complete payment.</p>
</div>

<!-- Step 4: Result -->
<div *ngIf="currentStep === 4" class="fiserv-pos-step fiserv-pos-step--centered">

  <!-- Success -->
  <ng-container *ngIf="paymentSucceeded">
    <div class="fiserv-pos-result fiserv-pos-result--success">&#10003;</div>
    <p class="fiserv-pos-result-label fiserv-pos-result-label--success">Approved</p>
    <dl class="fiserv-pos-details">
      <dt>Amount</dt><dd>{{ displayAmountLabel }}</dd>
      <ng-container *ngIf="authResponse?.retref">
        <dt>Reference</dt><dd>{{ authResponse?.retref }}</dd>
      </ng-container>
      <ng-container *ngIf="authResponse?.authCode">
        <dt>Auth Code</dt><dd>{{ authResponse?.authCode }}</dd>
      </ng-container>
      <ng-container *ngIf="authResponse?.cardBrand">
        <dt>Card</dt>
        <dd>{{ authResponse?.cardBrand }} **** {{ authResponse?.cardLastFour }}</dd>
      </ng-container>
    </dl>
    <div class="fiserv-pos-actions">
      <button class="fiserv-pos-btn fiserv-pos-btn--success" (click)="done()">Done</button>
    </div>
  </ng-container>

  <!-- Failure -->
  <ng-container *ngIf="!paymentSucceeded">
    <div class="fiserv-pos-result fiserv-pos-result--failure">&#10007;</div>
    <p class="fiserv-pos-result-label fiserv-pos-result-label--failure">
      {{ authResponse?.respStat === 'C' ? 'Declined' : 'Failed' }}
    </p>
    <p class="fiserv-pos-error-text" *ngIf="authResponse?.respText">
      {{ authResponse?.respText }}
    </p>
    <p class="fiserv-pos-error-text" *ngIf="errorMessage">{{ errorMessage }}</p>
    <div class="fiserv-pos-actions fiserv-pos-actions--split">
      <button class="fiserv-pos-btn fiserv-pos-btn--secondary" (click)="cancel()">Cancel</button>
      <button class="fiserv-pos-btn fiserv-pos-btn--primary" (click)="tryAgain()">Try Again</button>
    </div>
  </ng-container>

</div>
